import { KustomerConfig, AppConfig } from "./ChatConfig"

const brandId = '5eda9fd45679130013f3d423'

export let kustomerConfig: { [key: string]: KustomerConfig } = {
  'US': {
    brandId,
    apiKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYwMzk0ZDE5MTRlZTJjMDA4ZTNhNTFjMyIsInVzZXIiOiI2MDM5NGQxODZkZTNjZjY5MWI4NWJkYzYiLCJvcmciOiI1ZWRhOWZkMTM4Y2U3ZjAwMTRlYmNkZjgiLCJvcmdOYW1lIjoieW91bmdsaXZpbmciLCJ1c2VyVHlwZSI6Im1hY2hpbmUiLCJwb2QiOiJwcm9kMSIsInJvbGVzIjpbIm9yZy50cmFja2luZyJdLCJhdWQiOiJ1cm46Y29uc3VtZXIiLCJpc3MiOiJ1cm46YXBpIiwic3ViIjoiNjAzOTRkMTg2ZGUzY2Y2OTFiODViZGM2In0.TqQIfBv1gyeY_tgjeobq1HknE7Aaah1MdW6eSq9Ii6M',
    assistantId: '61570918cf4f74001af13c04',
    scheduleId: '601edb3e8ebda0001a9547c6'
  },
  'CA': {
    brandId,
    apiKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYwMzk0ZDhiZTA4ZmE4MDA4ZTk1YTk3MCIsInVzZXIiOiI2MDM5NGQ4YTZjNDZmNDRkZmYxNWY0MDMiLCJvcmciOiI1ZWRhOWZkMTM4Y2U3ZjAwMTRlYmNkZjgiLCJvcmdOYW1lIjoieW91bmdsaXZpbmciLCJ1c2VyVHlwZSI6Im1hY2hpbmUiLCJwb2QiOiJwcm9kMSIsInJvbGVzIjpbIm9yZy50cmFja2luZyJdLCJhdWQiOiJ1cm46Y29uc3VtZXIiLCJpc3MiOiJ1cm46YXBpIiwic3ViIjoiNjAzOTRkOGE2YzQ2ZjQ0ZGZmMTVmNDAzIn0.r18AKTXe8MGpoluqorhFMYedFy_-FivBhgHQZQgUhX0',
    assistantId: '61572a215fd08c001aa14b4c',
    scheduleId: '601edbbe8ebda0001a9547fd'
  }
}
